import type { SaUser } from '@/mocks/saUsers';

type SaUserType = SaUser['userType'];
type AccountStatus = SaUser['accountStatus'];

export const userTypeLabels: Record<SaUserType, string> = {
  oyente: 'Oyente',
  admin_radio: 'Admin de Radio',
  locutor: 'Locutor',
  moderador: 'Moderador',
  embajador: 'Embajador',
  anunciante: 'Anunciante',
  soporte: 'Soporte',
  personal_interno: 'Personal Interno',
  super_admin: 'Super Admin',
};

export const userTypeAccents: Record<SaUserType, string> = {
  oyente: 'bg-green-50 text-green-700 border-green-200',
  admin_radio: 'bg-blue-50 text-blue-700 border-blue-200',
  locutor: 'bg-amber-50 text-amber-700 border-amber-200',
  moderador: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  embajador: 'bg-pink-50 text-pink-700 border-pink-200',
  anunciante: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  soporte: 'bg-teal-50 text-teal-700 border-teal-200',
  personal_interno: 'bg-slate-50 text-slate-700 border-slate-200',
  super_admin: 'bg-red-50 text-red-700 border-red-200',
};

export const statusLabels: Record<AccountStatus, string> = {
  activo: 'Activo',
  suspendido: 'Suspendido',
  bloqueado: 'Bloqueado',
  pendiente: 'Pendiente',
};

export const statusAccents: Record<AccountStatus, string> = {
  activo: 'bg-green-50 text-green-700',
  suspendido: 'bg-amber-50 text-amber-700',
  bloqueado: 'bg-red-50 text-red-700',
  pendiente: 'bg-blue-50 text-blue-700',
};

export const verificationLabels: Record<string, string> = {
  verificado: 'Verificado',
  pendiente: 'Pendiente',
  no_verificado: 'No Verificado',
};

export const verificationAccents: Record<string, string> = {
  verificado: 'bg-green-50 text-green-700',
  pendiente: 'bg-amber-50 text-amber-700',
  no_verificado: 'bg-slate-50 text-slate-700',
};